<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        title="방지시설 운전사항"
        tableId="table"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :usePaging="false"
        :hideBottom="true"
        :columnSetting="false"
        :filtering="false"
        :isExcelDown="false"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="저장" icon="save" v-if="!param.isFullScreen" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'daily-air-report-02',
  props: {
    param: {
      type: Object,
      default: () => ({
        reportId: '',
        isFullScreen: false,
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '방지시설',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '설치위치',
            align: 'left',
            sortable: false,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '전일지침',
            align: 'center',
            type: 'number',
            sortable: false,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '금일지침',
            align: 'center',
            type: 'number',
            sortable: false,
          },
          {
            name: 'col6',
            field: 'col6',
            label: '사용량(kW/h)',
            align: 'center',
            type: 'number',
            sortable: false,
          },
          {
            name: 'col7',
            field: 'col7',
            label: '처리용량(M3/MIN)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col8',
            field: 'col8',
            label: '처리오염물질',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col9',
            field: 'col9',
            label: '처리농도(ppm/mg/Sm3)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col10',
            field: 'col10',
            label: '처리효율(%)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col11',
            field: 'col11',
            label: '사용약품1',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'col12',
            field: 'col12',
            label: '사용량1',
            align: 'center',
            type: 'number',
            sortable: false,
          },
          {
            name: 'col13',
            field: 'col13',
            label: '사용약품2',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'col14',
            field: 'col14',
            label: '사용량2',
            align: 'center',
            type: 'number',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
    if (this.param.isFullScreen) {
      this.grid.height = 'auto';
    }
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.grid.data = [
        {
          col0: '방지시설1',
          col3: '1공장 A01-01',
          col4: '100',
          col5: '160',
          col6: '60',
          col7: '60',
          col8: '오염물질처리액',
          col9: '10',
          col10: '90',
          col11: '',
          col12: '',
          col13: '',
          col14: '',
        },
        {
          col0: '방지시설2',
          col3: '1공장 A01-02',
          col4: '100',
          col5: '160',
          col6: '60',
          col7: '60',
          col8: '오염물질처리액',
          col9: '10',
          col10: '90',
          col11: '',
          col12: '',
          col13: '',
          col14: '',
        },
        {
          col0: '방지시설3',
          col3: '1공장 A01-03',
          col4: '100',
          col5: '160',
          col6: '60',
          col7: '60',
          col8: '오염물질처리액',
          col9: '10',
          col10: '90',
          col11: '',
          col12: '',
          col13: '',
          col14: '',
        },
        {
          col0: '방지시설4',
          col3: '1공장 A01-04',
          col4: '100',
          col5: '160',
          col6: '60',
          col7: '60',
          col8: '오염물질처리액',
          col9: '10',
          col10: '90',
          col11: '',
          col12: '',
          col13: '',
          col14: '',
        },
      ]
    },
  }
};
</script>
